// Simple API utilities (CRA)
const isBrowser = typeof window !== 'undefined' && !!window.location;
const devPorts = new Set(['3000', '5173']);
const isKnownDevPort = isBrowser && devPorts.has(window.location.port);

const API_BASE_RAW =
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_FANPAGE_API ||
  (isKnownDevPort ? 'http://localhost:5010' : '');
const API_BASE = typeof API_BASE_RAW === 'string' ? API_BASE_RAW.replace(/\/+$/, '') : '';

function withBase(url) {
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith('/api')) {
    if (API_BASE) {
      if (/\/api$/i.test(API_BASE)) return `${API_BASE}${url.replace(/^\/api/, '')}`;
      return `${API_BASE}${url}`;
    }
    return url;
  }
  return url;
}

export async function fetchJSON(path, init) {
  const url = withBase(path);
  const res = await fetch(url, init);
  const ct = res.headers.get('content-type') || '';
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`HTTP ${res.status} ${res.statusText}.\n${text.slice(0, 300)}`);
  }
  if (!ct.includes('application/json')) {
    const text = await res.text();
    throw new Error(`Expected application/json but got '${ct}'.\n${text.slice(0, 300)}`);
  }
  return res.json();
}

export function assetUrl(url) {
  if (!url) return url;
  if (/^gs:\/\//i.test(url)) {
    const path = String(url).replace(/^gs:\/\//i, '');
    url = `https://storage.googleapis.com/${path}`;
  }
  if (/^https:\/\/storage\.cloud\.google\.com\//i.test(String(url))) {
    url = String(url).replace('https://storage.cloud.google.com/', 'https://storage.googleapis.com/');
  }
  if (/^https:\/\/(storage\.googleapis\.com|storage\.cloud\.google\.com)\//i.test(String(url))) {
    const base = API_BASE
      ? (/\/api$/i.test(API_BASE) ? API_BASE : `${API_BASE}/api`)
      : '/api';
    return `${base}/media-proxy?url=${encodeURIComponent(String(url))}`;
  }
  if (/^https?:\/\//i.test(String(url))) return url;
  if (url.startsWith('/api/uploads')) {
    const stripped = url.replace(/^\/api/, '');
    return API_BASE ? `${API_BASE}${stripped}` : stripped;
  }
  if (url.startsWith('/uploads')) {
    return API_BASE ? `${API_BASE}${url}` : url;
  }
  return url;
}
